module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure"
    }
  }, [_c('div', {
    staticClass: "epigraph"
  }, [_c('p', {
    staticClass: "eps"
  }, [_c('a', {
    staticClass: "page",
    attrs: {
      "id": "pv"
    }
  }), _vm._v("It is certainly not an overstatement to say that no one has ever spoken so greatly and so nobly of what a philosopher is as Nietzsche.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("Leo Strauss")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b098ee2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-lampert-0005.vue
// module id = 66
// module chunks = 0